import React from "react";

export class JackpotIznos extends React.Component {
    constructor(props) {
        super(props);
        this.renderChar = this.renderChar.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    render() {
        return <div className="jackpotIznos">
            {this.props.iznos && casino.utils.numberToString(this.props.iznos).split('').map(this.renderChar)}
            <span className="jackpotIznos--kune">kn</span>
        </div>
    }

    renderChar(char, index) {
        var klasa = '';
        if (!isNaN(char))
            klasa += ' jackpotIznos--number';
        if (char == '.')
            klasa += ' small-mobile-hidden';

        return <span key={index} className={klasa}>{char}</span>;
    }
};
